/** @format */

export default class ScrollSpy {
	constructor() {
		this.instance = self;
		this.anchorBtns = document.querySelectorAll(".js-anchor-btn");
		this.activeSection = null; // Track the currently active section
	}

	static init() {
		const self = new ScrollSpy();
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		self.watchSections();
	}

	watchSections() {
		const self = this;

		let observer = new IntersectionObserver(
			(entries) => {
				// Filter entries that are intersecting
				const visibleSections = entries
					.filter((entry) => entry.isIntersecting)
					.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

				if (visibleSections.length > 0) {
					// Choose the section closest to the top of the viewport
					const topSection = visibleSections[0].target.id;

					// Avoid unnecessary DOM updates if the section is already active
					if (self.activeSection !== topSection) {
						self.activeSection = topSection;

						// console.log(topSection);
						self.toggleActiveAnchorBtn(topSection);
					}
				}
			},
			{
				root: null, // Defaults to viewport
				rootMargin: this.getRootMargin(), // Adjust rootMargin based on screen size
				threshold: this.getThreshold(), // Adjust threshold for smaller screens
			}
		);

		// Watch each section with a specific ID
		document.querySelectorAll("[data-section-anchor-id]").forEach((section) => {
			observer.observe(section);
		});
	}

	// Method to add active class to the navigation square
	toggleActiveAnchorBtn(sectionId) {
		this.anchorBtns.forEach((anchor) => {
			const anchorHref = anchor.getAttribute("href");
			const anchorId = anchorHref ? anchorHref.replace("#", "") : null;

			if (anchorId === sectionId) {
				anchor.classList.add("is-active");
			} else {
				anchor.classList.remove("is-active");
			}
		});
	}

	// Adjust rootMargin for smaller viewports
	getRootMargin() {
		if (window.innerWidth <= 768) {
			// For mobile, make rootMargin smaller
			return "0px 0px -25% 0px";
		}
		// Default for larger viewports
		return "0px 0px -50% 0px";
	}

	// Adjust threshold for smaller viewports
	getThreshold() {
		if (window.innerWidth <= 768) {
			// For mobile, increase sensitivity to ensure better behavior
			return [0.2]; // Trigger when 20% of the section is visible
		}
		// Default for larger viewports
		return [0.5]; // Trigger when 50% of the section is visible
	}
}
